import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { selectCenter } from "redux/reducers/selectedCenterReducer";
import { useLocation, useNavigate } from "react-router-dom";
import { RolesManager } from "utils/RolesManager";
import useSortedCenters from "hooks/useSortedCenters";

const DropdownCenterSelector = () => {
  const { user } = useSelector(state => state.userAuthentication)
  const allCenters = useSelector(({ centers }) => centers)?.data
  const selectedCenter = useSelector(({ center }) => center)?.data;

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const userCenters = user.centers;


  const dispatch = useDispatch();

  const handleChange = (event) => {
    const selectedCenterObj = event.target.value;
    dispatch(selectCenter(selectedCenterObj))

    if (pathname.includes("fichas-de-centro")) {
      navigate(`gestio-dels-centres/${selectedCenterObj.id}/fichas-de-centro`);
    }
  };

  const dropdownCenters = RolesManager.userIsSuperAdmin(user.roles) ? allCenters : userCenters

  const sortedCenters = useSortedCenters(dropdownCenters)

  if (!dropdownCenters) return null

  const findSelectedCenter = dropdownCenters.find(center => center.id === selectedCenter.id)

  if (!findSelectedCenter) return null

  return (
    <>
      <FormControl
        sx={{ m: 1, minWidth: "25%", position: "absolute", left: "64px" }}
      >
        <Select
          labelId='center-selector-label'
          id='center-selector'
          value={findSelectedCenter}
          label={null}
          onChange={handleChange}
          sx={{
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 5,
          }}
        >
          {sortedCenters.map((center) => (
            <MenuItem key={center.id} value={center}>
              {center.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default DropdownCenterSelector;
